export default __webpack_public_path__ + "static/media/add.7c9e02bd.svg";